// Body of the lookup-orders-by-email ("Order Status") page: the toppers
// customer-service side-nav account shell -- the "My Account" content title
// and the email form rendered as a native React field tree. The help / submit
// copy arrives as props (server-side gettext), matching
// lookup-orders-by-email.html.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_FIELD_SUBMIT_CLASS_NAME,
    FORM_HELP_TEXT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountShell } from "../AccountShell";

type IProps = Immutable<templates.LookupOrdersByEmailDocumentTemplate>;

export const LookupOrdersByEmailBody = (props: IProps): React.JSX.Element => (
    <AccountShell
        hasNav={props.has_nav}
        sideNav={props.side_nav}
        title={props.content_title}
        phoneDisplay={props.phone_display}
        phoneHref={props.phone_href}
    >
        <p className={FORM_HELP_TEXT_CLASS_NAME} data-testid="form-help-text">
            {props.help_text}
        </p>
        <div className="my-account-form">
            <form
                id="lookup-orders-by-email-form"
                className="js-kuid-form"
                action={props.action_url}
                method="post"
            >
                <CSRFToken />
                <FormFields
                    fields={props.fields}
                    field_labels={props.field_labels}
                    field_errors={props.field_errors}
                    non_field_errors={props.non_field_errors}
                />
                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                    <input
                        type="submit"
                        className="button button--full-width"
                        value={props.submit_text}
                    />
                </div>
            </form>
        </div>
    </AccountShell>
);
